var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18.913,
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#033030",
    "data-name": "Group 188"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7.94a7.88 7.88 0 0 1 2.549-5.8A7.6 7.6 0 0 1 6.982.061a7.8 7.8 0 0 1 6.888 2.5 7.72 7.72 0 0 1 2.078 4.512 8 8 0 0 1-1.022 4.829 17.2 17.2 0 0 1-3.371 4.249c-.837.8-1.707 1.563-2.567 2.338a1.36 1.36 0 0 1-1.919.045 48 48 0 0 1-3.6-3.37A14.8 14.8 0 0 1 .73 11.205 7.8 7.8 0 0 1 0 7.94m8.276-6.842a7.3 7.3 0 0 0-2.654.438 6.79 6.79 0 0 0-4.4 5.274 6.2 6.2 0 0 0 .321 3.446 12.3 12.3 0 0 0 2.292 3.654 42 42 0 0 0 3.944 3.781c.174.156.28.149.468-.019.615-.55 1.232-1.1 1.841-1.654a20 20 0 0 0 3.42-3.883 8.7 8.7 0 0 0 1.217-2.753 6.33 6.33 0 0 0-.523-4.363 6.73 6.73 0 0 0-5.926-3.922Z",
    "data-name": "Path 312"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.523 7.688a3.523 3.523 0 1 1-3.524-3.522 3.537 3.537 0 0 1 3.524 3.522m-1.109.008a2.413 2.413 0 1 0-2.424 2.413 2.416 2.416 0 0 0 2.424-2.413",
    "data-name": "Path 313"
  }))));
};
export default SvgPin;